import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FolderActionsService} from '../../../../services/sp-folder/folder-actions.service';
import {AnyFolder} from '../../../../services/sp-project/project-manager.service';

@Component({
  selector: 'app-sp-modal-project-list-folder-delete',
  templateUrl: './sp-modal-project-list-folder-delete.component.html',
  styleUrls: ['./sp-modal-project-list-folder-delete.component.scss']
})
export class SpModalProjectListFolderDeleteComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SpModalProjectListFolderDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) private data: AnyFolder,
    private folderActions: FolderActionsService) { }

  ngOnInit() {
  }

  folderDelete() {
    this.folderActions.deleteFolder(this.data).then(() => {
      this.dialogRef.close(this.data.projects);
    });
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

}
